import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
// import Card from "react-bootstrap/Card";
import couterpart from 'counterpart';

import WorkOrderDataService from '../services/WorkOrderDataService';

class WorkerPlan extends Component {
  constructor () {
    super();
    this.state = {
      workerPlans: [],
      childRefreshCount: 0
    };
  }

  componentDidMount () {
    if (this.props.isFuture === 1){
      this.setState({ 
          workerPlans:  this.props.workerPlans
      });
    } else {
      WorkOrderDataService.fetchWorkerPlans().then(data => {
        console.log('Worker Plans', data)
        this.setState({ 
            workerPlans:  data
        });
      });
    }
    
  }

  renderValue(vl){
    return (
      <>
        {vl <= 0? (
        <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
          {vl}
        </div>
        ) : (
        <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
            <b className='fmt'>{vl} </b>
        </div>
        )}
      </>
    )
  }

  renderWorkerPlans() {
    if (this.state.workerPlans === undefined || this.state.workerPlans === null || !(this.state.workerPlans instanceof Array)){
        return (<></>);
    }
    return (
      <>
          <div className="row">
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { 'STT' }
              </div>
              <div className="col-2 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('worker_name') }
              </div>              
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_assigned_total') }
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_ready') }
              </div>                    
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_assigned') }
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_ck') }
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_nham') }
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_bong') }
              </div>                                        
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_kiemtra') }
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_loichosua') }
              </div>
              <div className="col-1 border-top border-left border-right border-light-gray table_header">
                { couterpart.translate('status_kim') }
              </div>              
          </div>
        {this.state.workerPlans.map((item, index) => {
          if (index % 2 === 0){
            return (
              <div className="row" key={item.workerId} style={{ backgroundColor: "lightblue"}}>
                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{ index + 1 }</label>
                </div>                
                <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{item.workerName}</label>
                </div>
                { this.renderValue(item.readyCount + item.assignedCount + item.ckCount + item.nhamCount + item.bongCount + item.kiemtraCount + item.loichosuaCount) }
                { this.renderValue(item.readyCount) }
                { this.renderValue(item.assignedCount) }
                { this.renderValue(item.ckCount) }
                { this.renderValue(item.nhamCount) }
                { this.renderValue(item.bongCount) }
                { this.renderValue(item.kiemtraCount) }
                { this.renderValue(item.loichosuaCount) }
                { this.renderValue(item.kimCount) }                
              </div>
            )
          } else {
            return (
              <div className="row" key={item.workerId} style={{ backgroundColor: "white"}}>
                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{ index + 1 }</label>
                </div>
                <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                  <label className="label_link">{item.workerName}</label>
                </div>
                { this.renderValue(item.readyCount + item.assignedCount + item.ckCount + item.nhamCount + item.bongCount + item.kiemtraCount + item.loichosuaCount) }
                { this.renderValue(item.readyCount) }
                { this.renderValue(item.assignedCount) }
                { this.renderValue(item.ckCount) }
                { this.renderValue(item.nhamCount) }
                { this.renderValue(item.bongCount) }
                { this.renderValue(item.kiemtraCount) }
                { this.renderValue(item.loichosuaCount) }
                { this.renderValue(item.kimCount) }                
              </div>
            )            
          }
        })
      }
      </>);
    }

  render() {
    return (
      <div style={{ width: "100%"}}>
         { this.renderWorkerPlans() }
      </div>
    )
  }
}

export default withRouter(WorkerPlan);